import { useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';

export default function useIsSidebarSticky(loaded: boolean, width: number) {
  const config = useAppSelector(ConfigSlice.selectors.config);

  const enableStickyMobileHead = config.header.enableStickyMobileHead || false;

  return loaded && enableStickyMobileHead && width < 768;
}
